export const NAVIGATION_ICON_PACK = 'far'
export const NAVIGATION_ROOT_DROP_ID = '_root'
